const copyToBuffer = (text, onCopy = () => {
}) => {
  if (text) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      onCopy();
    } else {
      const textField = document.createElement("textarea");
      textField.innerText = text;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand("copy");
      textField.remove();
      onCopy();
    }
  }
};

export { copyToBuffer };
//# sourceMappingURL=copy-to-buffer.js.map
